import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store';
import { selectIdentity } from '../../../store/entities/identity';
import { getFirstLastNameObj } from '../../../utils/format';
import QcsAlert from '../basic/QcsAlert';
import { QcsAutocompleteWithoutFormik } from '../form/QcsAutocompleteWithoutFormik';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserState } from '@api/models/enums/UserState';
import { UserRole } from '@api/models/enums/UserRole';
import { SupplierEmployeeOptionDto, useSupplierEmployeeOrVisitOptions } from '../../../hooks/useSupplierEmployeeOrVisitOptions';
import { QcsBox } from '../basic/QcsBox';

interface Props {
  supplierId?: string;
  role?: UserRole;
  state?: UserState[];
  value?: SupplierEmployeeDto;
  onChange: (value?: SupplierEmployeeDto) => void;
}

export const GridFilterSupplierEmployee: FC<Props> = ({ supplierId, role, state, value, onChange }) => {
  const { t } = useTranslation();
  const identity = useAppSelector(selectIdentity);

  const isVisit = !supplierId && !identity.supplier;
  const resolvedSupplierId = supplierId || identity.supplier || undefined;

  const { options, loading, loadingError, loadOptions, handleGetValueIfNotFound } = useSupplierEmployeeOrVisitOptions({
    isVisit,
    supplierId: resolvedSupplierId,
    role,
    state,
  });

  const handleChange = (value?: SupplierEmployeeOptionDto | SupplierEmployeeOptionDto[] | null) => {
    onChange((value as SupplierEmployeeDto) ?? undefined);
  };

  return (
    <>
      {isVisit && (
        <QcsBox sx={{ width: '100%', overflow: 'hidden', marginBottom: '1rem' }}>
          <QcsAlert sx={{ '& .MuiAlert-message': { padding: '8px' } }} severity="info">
            {t('invitation.noSupplierFilteringVisitsOnly')}
          </QcsAlert>
        </QcsBox>
      )}
      <QcsAutocompleteWithoutFormik
        options={options}
        loading={loading}
        loadingError={loadingError}
        loadOptions={loadOptions}
        value={value as SupplierEmployeeOptionDto}
        getOptionId={(option: SupplierEmployeeOptionDto) => option.id!}
        getOptionName={getFirstLastNameObj}
        getValueIfNotFound={handleGetValueIfNotFound}
        onChange={handleChange}
      />
    </>
  );
};
